import { useState } from "react";
import i18next from "i18next";
import { Trans as T } from 'react-i18next';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Link, useNavigate } from "react-router-dom";
import { setLanguage } from "../../locale/localeUtils";

import AuthForm from "./AuthForm";
import Form from 'react-bootstrap/Form';

import { ReactComponent as CheckIcon } from '../../assets/icons_svg/check-mark-outline.svg';

import './Signup.scss';

export default function SignUp() {
  const [signupLang, setSignupLang] = useState(() => i18next.language);
  const navigate = useNavigate();

  const changeLanguage = e => {
    const lang = e.target.value;
    setLanguage(lang);
    setSignupLang(lang);

    navigate(lang === 'en' ? '/signup' : `/${lang}/signup`);
  }

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}>
      <div className="__signup">
        <div className="navigation">
          <div className="inner-content">
            <h1><a href='https://preciousleads.com'>Precious Leads</a></h1>
            <div className="nav-buttons">
              <Link to='#WIP'>Features</Link>
              <Link to='#WIP'>Pricing</Link>
              <Link to='#WIP'>Questions?</Link>
              <Link to='/login'>Login</Link>
            </div>
          </div>
        </div>
        <div className="headline-signup">
          <div className="headline-sub">
            <h2>The Simplest Lead Management Software You'll Ever Use</h2>
            <p>Stop using spreadsheets or complicated CRMs nobody wants to open. <strong>Precious Leads is simple enough that your team will actually use it.</strong></p>
            
            <div className="feature"><CheckIcon /> <span><strong>Free forever plan.</strong> 1000 leads on us.</span></div>
            <div className="feature"><CheckIcon /> <span><strong>Set up in minutes.</strong> The most minimalistic CRM in the world.</span></div>
            <div className="feature"><CheckIcon /> <span>Built in Costa Rica by pro players from the best university.</span></div>
          </div>
          
          <div className="form-language">
            <AuthForm type='signup' hideTitle signUpText={<T>Get started for free</T>} />

            <Form.Group className='language-select'>
              <Form.Label><T>Language</T></Form.Label>
              <Form.Select value={signupLang} onChange={changeLanguage}>
                <option value="en">English</option>
                <option value="es">Español</option>
              </Form.Select>
            </Form.Group>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}
